@if(isAudio()){
<div class="audio-player-container-mobile" [class.hidden]="isHidden()">

    <div class="header">
        <div class="info">
            <div class="image-wrapper">
                @if(cover()){
                    <img [src]="cover()" />
                }
                @else {
                    <icon-no-cover />
                }
            </div>
            @if(title() || address()){
                <div class="name">
                    <span class="title">{{title()}}</span>
                    <span class="address">{{address()}}</span>
                </div>
            }
        </div>
        <icon-close (click)="closeAudioPlayer()" />
    </div>

    <div class="audio-info">
        <span>{{playingDurationString()}}</span>
        <mat-slider [min]="0" [max]="duration()" step="0.1">
            <input matSliderThumb [value]="currentTime()" (valueChange)="changeValue($event)">
        </mat-slider>
        <span>{{durationString()}}</span>
    </div>

    <div class="controls">
        <icon-expand (click)="openAudioModal()" />
        <icon-backward (click)="handleBackward()" />
        @if(isPlaying()){
            <icon-pause (click)="handlePlayPause()"/>
        }
        @else {
            <icon-play (click)="handlePlayPause()" />
        }
        <icon-forward (click)="handleForward()" />
        @if(isMuted()){
            <icon-volume-off (click)="toggleMute()" />
        }
        @else {
            <icon-volume-on (click)="toggleMute()" />
        }
    </div>

</div>

<div class="audio-player-container-desktop" [class.hidden]="isHidden()">

    <div class="audio-info">
        <span>{{playingDurationString()}}</span>
        <mat-slider [min]="0" [max]="duration()" step="0.1">
            <input matSliderThumb [value]="currentTime()" (valueChange)="changeValue($event)">
        </mat-slider>
        <span>{{durationString()}}</span>
        <icon-close (click)="closeAudioPlayer()" />
    </div>

    <div class="audio-wrapper">
        <div class="info">
            <div class="image-wrapper" (click)="openAudioModal()">
                @if(cover()){
                    <img class="cover" [src]="cover()" />
                }
                @else {
                    <icon-no-cover />
                }
                <img class="overlay" src="/assets/imgs/img-hovered.png" />
            </div>
            @if(title() || address()){
                <div class="name">
                    <span class="title">{{title()}}</span>
                    <span class="address">{{address()}}</span>
                </div>
            }
            @if(isMuted()){
                <icon-volume-off (click)="toggleMute()" />
            }
            @else {
                <icon-volume-on (click)="toggleMute()" />
            }
        </div>
        <div class="controls">
            <icon-backward (click)="handleBackward()" />
                @if(isPlaying()){
                    <icon-pause (click)="handlePlayPause()"/>
                }
                @else {
                    <icon-play (click)="handlePlayPause()" />
                }
            <icon-forward (click)="handleForward()" />
        </div>
    </div>

</div>
}
